module.exports = __webpack_public_path__ + "img/martini.97e675ba.png";